import { joinClassnames } from 'helpers/classNames';
import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './BlackOverlay.module.scss';
import { TBlackOverlay } from './definitions';

export default function BlackOverlay({ show, onClick }: TBlackOverlay) {
  return (
    <div
      onClick={onClick}
      className={joinClassnames(
        Styles['black-overlay'],
        !show && Styles['hide'],
      )}
    />
  );
}
